export default __webpack_public_path__ + "static/media/GabrielCharib.7872e834.png";